import { useCompanyReadDataContext } from '@aibees/elephant/context';
import { useMemo } from 'react';

export function useFundingRounds() {
  const { api } = useCompanyReadDataContext();

  return useMemo(() => {
    const rounds = api?.data?.financial?.funding?.rounds;
    if (!rounds) return [];

    return rounds
      .filter(
        (round) =>
          round &&
          (round.raised_amount != null ||
            round.announced_at != null ||
            round.type != null)
      )
      .sort((a, b) => {
        const dateA = a.announced_at ? new Date(a.announced_at).getTime() : 0;
        const dateB = b.announced_at ? new Date(b.announced_at).getTime() : 0;
        return dateA - dateB;
      });
  }, [api?.data?.financial?.funding?.rounds]);
}
